import { createI18n } from 'vue-i18n';
import { sharedMessages } from '@sys/shared/locales';
import { STORAGE_KEYS, DEFAULT_LOCALE } from '@sys/shared/constants';
import { cache } from '@sys/shared/utils';
import zhCN from './lang/zh-CN/index.mjs';
import zhTW from './lang/zh-TW/index.mjs';
import enUS from './lang/en-US/index.mjs';
import ja from './lang/ja/index.mjs';

// 合并公共词条 + 品牌后台词条
function mergeMessages() {
  return {
    'zh-CN': { ...sharedMessages['zh-CN'], ...zhCN },
    'zh-TW': { ...sharedMessages['zh-TW'], ...zhTW },
    'en-US': { ...sharedMessages['en-US'], ...enUS },
    ja: { ...sharedMessages.ja, ...ja },
  };
}

const savedLocale = cache.get(STORAGE_KEYS.LOCALE, DEFAULT_LOCALE);

export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: savedLocale,
  fallbackLocale: 'zh-CN',
  messages: mergeMessages(),
});
